/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zipcity1Inputs */

const en__field_zipcity1 = /** @type {(inputs: _Field_Zipcity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de__field_zipcity1 = /** @type {(inputs: _Field_Zipcity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {_Field_Zipcity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_zipcity1 = /** @type {((inputs?: _Field_Zipcity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zipcity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_zipcity1(inputs)
	return de__field_zipcity1(inputs)
});
export { _field_zipcity1 as "_field_zipCity" }